import { CountriesEnum } from 'src/generated/operations';

export const UNIT_SWITCH_COUNTRIES: CountriesEnum[] = [
    CountriesEnum.Br,
    CountriesEnum.Ca,
    CountriesEnum.Gb,
    CountriesEnum.Hk,
];
